<template>
    <div class="invoice">
        <el-container>
            <el-header>
                <el-form :inline="true" :model="dataForm" label-width="100px">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="项目部：">
                                <el-select v-model="dataForm.deptId" placeholder="请选择项目部" @change="getProjectList">
                                    <el-option :label="deptItem.applyDeptName" :value="deptItem.applyDeptId" v-for="(deptItem,deptIndex) in deptList" :key="'deptItem'+deptIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="项目名称：">
                                <el-select v-model="dataForm.projectId" placeholder="请选择项目名称">
                                    <el-option :label="projectItem.name" :value="projectItem.id" v-for="(projectItem,projectIndex) in projectList" :key="'projectItem'+projectIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="分项合同名称：">
                                <el-input v-model="dataForm.subContractName" placeholder="请输入分项合同名称" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <div v-if="showAdvanceFilter">
                            <el-col :span="6">
                                <el-form-item label-width="120px" label="分项合同名编号：">
                                    <el-input v-model="dataForm.subContractSerial" placeholder="请输入分项合同名编号" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="发票抬头：">
                                    <el-input v-model="dataForm.billHead" placeholder="请输入发票抬头" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="纳税人识别号：">
                                    <el-input v-model="dataForm.taxPayerCode" placeholder="请输入纳税人识别号" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="发票代码：">
                                    <el-input v-model="dataForm.billCode" placeholder="请输入发票代码" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="发票号码：">
                                    <el-input v-model="dataForm.billNumber" placeholder="请输入发票号码" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="不含税金额：">
                                    <div class="fixStyle">
                                        <el-input v-model="dataForm.amountWithoutTaxMin" placeholder="请输入最小不含税金额" clearable></el-input>
                                        <div class="lineBox">——</div>
                                        <el-input v-model="dataForm.amountWithoutTaxMax" placeholder="请输入最大不含税金额" clearable></el-input>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="税额：">
                                    <div class="fixStyle">
                                        <el-input v-model="dataForm.taxMin" placeholder="请输入最小税额" clearable></el-input>
                                        <div class="lineBox">——</div>
                                        <el-input v-model="dataForm.taxMax" placeholder="请输入最大税额" clearable></el-input>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="发票金额：">
                                    <div class="fixStyle">
                                        <el-input v-model="dataForm.amountMin" placeholder="请输入最小发票金额" clearable></el-input>
                                        <div class="lineBox">——</div>
                                        <el-input v-model="dataForm.amountMax" placeholder="请输入最大发票金额" clearable></el-input>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="税率：">
                                    <el-input v-model="dataForm.taxRate" placeholder="请输入税率" clearable></el-input>
                                </el-form-item>
                            </el-col>
                          <el-col :span="6">
                            <el-form-item label="认领日期：">
                              <el-date-picker
                                  v-model="dataForm.claimMonth"
                                  value-format="yyyy-MM"
                                  type="month"
                                  placeholder="选择认领日期">
                              </el-date-picker>
                            </el-form-item>
                          </el-col>
                            <el-col :span="6">
                                <el-form-item label="发票用途：">
                                    <el-select v-model="dataForm.billUsage" placeholder="请选择发票用途">
                                        <el-option label="工程款支付" value="PROJECT_PAY"></el-option>
                                        <el-option label="费用报销" value="COST"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="报销审批：">
                                    <el-select v-model="dataForm.approveStatus" placeholder="请选择报销审批">
                                        <el-option label="全部" value=""></el-option>
                                        <el-option label="审批中" :value="2"></el-option>
                                        <el-option label="已通过" :value="3"></el-option>
                                        <el-option label="未通过" :value="4"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="发票类型：">
                                    <el-select v-model="dataForm.billType" placeholder="请选择发票类型">
                                        <el-option label="增值税专用发票" value="VAT"></el-option>
                                        <el-option label="普通发票" value="PLAIN"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="发票种类：">
                                    <el-select v-model="dataForm.billInvoiceType" placeholder="请选择发票种类">
                                        <el-option label="电子发票" value="ELECTRONIC"></el-option>
                                        <el-option label="纸质发票" value="PAPER"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="是否认领：">
                                    <el-select v-model="dataForm.isClaimed" placeholder="请选择是否认领">
                                        <el-option label="全部" value=""></el-option>
                                        <el-option label="是" :value="1"></el-option>
                                        <el-option label="否" :value="0"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </div>
                        <el-col :span="showAdvanceFilter? 18: 6" class="btnRight">
                            <el-form-item class="btnList">
                                <el-button type="primary" @click="query()">查 询</el-button>
                                <el-button type="info" @click="reset()">重 置</el-button>
                                <el-button type="text" @click="moreScreen">{{showAdvanceFilter?'收起':'高级筛选'}}</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row>
                    <el-col :span="24">
                        <div class="operatePanel">
                            <el-button
                                    v-if="btnAuthorize.addBtn.btnEnable"
                                    type="primary"
                                    icon="el-icon-upload2"
                                    @click="goToIncomeInput()"
                            >发票录入</el-button>
                            <el-button
                                    v-if="btnAuthorize.update.btnEnable"
                                    type="primary"
                                    icon="el-icon-upload2"
                                    @click="modifyIncomeInput()"
                            >发票修改</el-button>
                            <el-button
                                    v-if="btnAuthorize.approve.btnEnable"
                                    type="primary"
                                    icon="el-icon-check"
                                    @click="setIncomeApprove()"
                            >报销审批</el-button>
                            <el-button
                                    v-if="btnAuthorize.export.btnEnable"
                                    type="primary"
                                    icon="el-icon-download"
                                    @click="exportBtn()"
                            >导出</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-header>
            <el-main ref="main">
                <el-table
                        ref="dataTable"
                        :data="invoiceList"
                        highlight-current-row
                        @selection-change="handleSelectionChange"
                        @row-click="rowClicked"
                        @cell-dblclick="dblclickDetail"
                        size="mini"
                        height="100%"
                        border
                >
                    <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                    <el-table-column
                            prop="deptName"
                            label="项目部"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="projectName"
                            label="项目名称"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="subContractName"
                            label="分项合同名称"
                            width="120px"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="subContractSerial"
                            label="分项合同编码"
                            width="120px"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="billHead"
                            label="发票抬头"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="taxPayerCode"
                            label="纳税人识别号"
                            width="120px"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="billCode"
                            label="发票代码"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="billNumber"
                            label="发票号码"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="amountWithoutTax"
                            label="不含税金额（元）"
                            width="120px"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            width="100px"
                            prop="tax"
                            label="税额（元）"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            width="100px"
                            prop="taxRateShow"
                            label="税率（%）"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            width="120px"
                            prop="amount"
                            label="发票金额（元）"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="billUsageShow"
                            label="发票用途"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="billTypeShow"
                            label="发票类型"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="billInvoiceTypeShow"
                            label="发票种类"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="createUserName"
                            label="提交人"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="createTime"
                            label="提交时间"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="isClaimedShow"
                            label="是否认领"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                      prop="claimDate"
                      label="认领日期"
                      :show-overflow-tooltip="true"
                  ></el-table-column>
                    <el-table-column
                            prop="approveStatusShow"
                            label="报销审批"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                </el-table>
                <div class="totalBox">
                  <div>合计：</div>
                  <div class="totalNum">不含税金额：{{amountWithoutTaxTotal}}元</div>
                  <div class="totalNum">税额：{{taxTotal}}元</div>
                  <div class="totalNum">发票金额：{{amountTotal}}元</div>
                </div>
            </el-main>
            <el-footer>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="dataForm.pageIndex"
                        :page-sizes="[10, 20, 30, 50, 100]"
                        :page-size="dataForm.pageSize"
                        layout="total, prev, pager, next, sizes, jumper"
                        :total="total"
                ></el-pagination>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
    import {
        getIncomeInvoiceService,
        getDeptListService,
        getProjectListService,
        exportInputBillService,
    } from '@/services/invoiceServices'
    import {exportExcelService2} from "../../../services/allContractServices";
    export default {
        name: "incomeInvoice",
        data(){
            return {
                dataForm:{
                    deptId:'',
                    projectId:'',
                    subContractName:'',
                    subContractSerial:'',
                    billHead:'',
                    taxPayerCode:'',
                    billCode:'',
                    billNumber:'',
                    notTaxPrice:'',
                    taxPrice:'',
                    taxRatio:'',
                    price:'',
                    billUsage:'',
                    approveStatus:'',
                    billInvoiceType:'',
                    billType:'',
                    isClaimed:'',
                    taxMin: '',
                    taxMax: '',
                    amountWithoutTaxMin:'',
                    amountWithoutTaxMax: '',
                    amountMax:'',
                    amountMin:'',
                    claimMonth:'',
                    pageIndex: 1,
                    pageSize: 10,
                },
                total:0,
                showAdvanceFilter: false,

                deptList:[], //项目部列表
                projectList:[], //项目列表
                invoiceList:[], //表格数据列表
                selectItems:[], //选中的列表
                btnAuthorize: {
                    addBtn: { key: "create", btnEnable: false },
                    update: { key: "update", btnEnable: false },
                    approve: { key: "approve", btnEnable: false }, //审核
                    export: { key: "export", btnEnable: false }
                },
                amountWithoutTaxTotal: 0, //不含税金额总和
                taxTotal: 0,  //税额总和
                amountTotal: 0,  //发票金额总和
            }
        },
        props: {
            menuCode: {
                type: String
            }
        },
        methods:{
            onActive(menuCode) {
                this.$getRoleBtns(menuCode, this.btnAuthorize);
                this.getInvoiceList();
                this.getDeptList();
            },
            //根据条件查询
            query(){
                this.getInvoiceList();
            },
            //重置数据
            reset(){
                this.dataForm = {
                    deptId:'',
                    projectId:'',
                    subContractName:'',
                    subContractSerial:'',
                    billHead:'',
                    taxPayerCode:'',
                    billCode:'',
                    billNumber:'',
                    notTaxPrice:'',
                    taxPrice:'',
                    taxRatio:'',
                    price:'',
                    billUsage:'',
                    approveStatus:'',
                    billInvoiceType:'',
                    billType:'',
                    isClaimed:'',
                    taxMin: '',
                    taxMax: '',
                    amountWithoutTaxMin:'',
                    amountWithoutTaxMax: '',
                    amountMax:'',
                    amountMin:'',
                    pageIndex: 1,
                    pageSize: 10,
                };
                this.projectList = [];
                this.getInvoiceList();
            },
            /**
             * 获取列表数据
             * */
            getInvoiceList(){
                let paramsData = {
                    ...this.dataForm
                }
                getIncomeInvoiceService(paramsData).then( res => {
                    if(res.code == 10000000){
                        console.log(res)
                        this.invoiceList = res.data;
                        this.total = res.total;

                      let amountWithoutTaxTotal = 0
                      let taxTotal = 0
                      let amountTotal = 0
                      res.data.map(item => {
                        amountWithoutTaxTotal+= item.amountWithoutTax;
                        taxTotal+= item.tax;
                        amountTotal+= item.amount;
                      })
                      this.amountWithoutTaxTotal = amountWithoutTaxTotal.toFixed(2)
                      this.taxTotal = taxTotal.toFixed(2)
                      this.amountTotal = amountTotal.toFixed(2)
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             *  获取项目部列表
             * */
            getDeptList(){
                getDeptListService().then( res => {
                    if(res.code == 10000000){
                        this.deptList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             *  获取项目列表
             * */
            getProjectList(){
                this.dataForm.projectId = '';
                let paramsData = {
                    deptId: this.dataForm.deptId
                }
                getProjectListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.projectList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },

            moreScreen() {
                this.showAdvanceFilter = !this.showAdvanceFilter;
            },
            // 列代表多选回调
            handleSelectionChange(val) {
                this.selectItems = val;
            },
            // 点击选中行
            rowClicked(row, event, column) {
                this.$refs.dataTable.toggleRowSelection(row);
            },
            dblclickDetail(row, column, cell, event) {
                this.bus.$emit("navMenuChange", {
                    routeId: "incomeInvoiceDetail",
                    routeParam: {
                        id: row.id
                    }
                });
            },
            // 分页改变事件
            handleCurrentChange(page) {
                this.dataForm.pageIndex = page;
                this.getInvoiceList();
            },
            // 分页显示数量改变事件
            handleSizeChange(rows) {
                this.dataForm.pageIndex = 1;
                this.dataForm.pageSize = rows;
                this.getInvoiceList();
            },
            goToIncomeInput(){
                this.bus.$emit("navMenuChange", {
                    routeId: "incomeInput",
                    routeParam: {

                    }
                });
            },
            modifyIncomeInput(){
                if(this.selectItems.length!= 0){
                    if(this.selectItems.length == 1){
                        if(this.selectItems[0].approveStatusShow == '待审批'){
                            this.$message.error("已提报审批不允许编辑");
                        }else if (this.selectItems[0].approveStatusShow == '已通过'){
                            this.$message.error("报销已审批不允许编辑");
                        }else{
                            this.bus.$emit("navMenuChange", {
                                routeId: "incomeInput",
                                routeParam: {
                                    id:this.selectItems[0].id
                                }
                            });
                        }

                    }else{
                        this.$message.error("请选择一条数据进行修改");
                    }
                }else {
                    this.$message.error("请选择一条数据进行修改");
                }

            },
            setIncomeApprove(){
                if(this.selectItems.length!= 0){
                    let flag = this.selectItems.every(item => item.projectName === this.selectItems[0].projectName)
                    if(flag){
                        let approveStatusFlag = this.selectItems.every(item => item.approveStatusShow === '已保存'||item.approveStatusShow === '已拒绝')
                        if(approveStatusFlag){
                            this.bus.$emit("navMenuChange", {
                                routeId: "incomeApprove",
                                routeParam: {
                                    invoiceList: this.selectItems
                                }
                            });
                        }else{
                            this.$message.error("有重复审批的数据");
                        }
                    }else{
                        this.$message.error("必须选择同一个项目的数据");
                    }
                }else{
                    this.$message.error("至少选择一条数据");
                }

            },
            exportBtn(){
                let paramsData = {
                    ...this.dataForm,
                    pageSize: 10000,
                }
                exportInputBillService(paramsData).then( res => {
                    if(res.code == 10000000){
                        exportExcelService2(res.data).then(res1 => {
                            this.$message.success('导出成功');
                        });
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .invoice {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
    }
    .btnRight {
        display: flex;
        justify-content: flex-end;
        .btnList{
            text-align: right;
        }
    }
    .fixStyle{
        display: flex;
        align-items: center;
        .lineBox{
            margin: 0 10px;
        }
    }
    .totalBox{
      margin-top: 12px;
      display: flex;
      align-items: center;
      font-weight: 600;
      .totalNum{
        margin: 0 12px 0  15px;
      }
    }
</style>
